import { createApp } from '@app/adapters/create-app'
import CompanyLinkCreator from '@app/application/company_links/components/company-link-creator.vue'

export default (): void => {
  window.onDomLoad(($dom) => {
    const doc = $dom[0]

    const element = doc.querySelector(
      "[data-behaviour='new-company-links-search-bar']"
    ) as HTMLElement

    if (element) {
      const { currentUserId } = element.dataset ?? {}
      createApp(CompanyLinkCreator, {
        currentUserId: currentUserId ? parseInt(currentUserId) : null,
      }).mount(element)
    }
  })
}
